import { createContext } from 'react';
import type { UseAuthResult } from './hooks/useAuth';

/**
 * Shared auth context provided by AuthGate.
 * When useAuth() is called inside an AuthGate, it reads from this context
 * so all components share the same auth state.
 */
export const AuthContext = createContext<UseAuthResult | null>(null);
